import React, { useState } from 'react';
import { colors, smallMobileMQ } from '../../modules/theme';
import SpeciesContent from '../species-content';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faTimes,
  faChevronLeft,
  faCaretDown,
} from '@fortawesome/pro-solid-svg-icons';
import useGlobalState from '../../hooks/use-global-state';
import { pixelToRem } from '../ui';
import {
  setActiveFrogType,
  setLGA,
  selectActiveLGAName,
  selectActiveFrogName,
} from '../../modules/app-duck';
import LGAContent from '../lga-content';

const Button = props => {
  return (
    <button
      css={{
        background: colors.blue,
        color: 'white',
        padding: '10px',
        display: 'flex',
        border: 'none ',
        fontWeight: 'bold',
        fontSize: pixelToRem(16),
        justifyContent: 'space-between',
        alignItems: 'center',
        borderRadius: '3px',
        [smallMobileMQ]: {
          fontSize: pixelToRem(18),
          lineHeight: '26px',
        },
      }}
      {...props}
    />
  );
};
const GhostDiv = () => {
  return (
    <div
      css={{
        width: 1,
        height: 40,
        margin: '10px 15px 0 15px',
      }}
    ></div>
  );
};

const getActionBtnWrapperStyles = active => {
  const stickyStyles = {
    position: 'fixed',
    width: 'calc(100% - 40px)',
    zIndex: 10,
    top: 0,
  };
  const defaultStyles = {
    background: colors.blue,
    color: 'white',
    height: 40,
    display: 'flex',
    margin: '10px 15px 0 15px',
    borderRadius: '3px',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0 10px',
    overflowY: 'auto',
  };
  if (active) {
    return { ...defaultStyles, ...stickyStyles };
  }
  return defaultStyles;
};

export default function MobileFilters() {
  const { state, dispatch } = useGlobalState();
  const [openFilter, setOpenFilter] = useState();
  return (
    <div>
      <div
        css={{
          background: colors.darkBlue,
          padding: 10,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Button
          onClick={() => {
            setOpenFilter('lga');
          }}
        >
          {state.lgaGeo ? selectActiveLGAName(state) : 'Filter by LGA'}
          <FontAwesomeIcon icon={faCaretDown} />
        </Button>
        <Button
          css={{
            marginTop: 2,
          }}
          onClick={() => {
            setOpenFilter('species');
          }}
        >
          {selectActiveFrogName(state) || 'Filter by Species'}
          <FontAwesomeIcon icon={faCaretDown} />
        </Button>
      </div>
      {openFilter && (
        <div
          css={{
            position: 'fixed',
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            zIndex: 100,
            background: colors.darkBlue,
            overflowY: 'auto',
          }}
        >
          {state.activeFrogType && <GhostDiv />}
          <div css={getActionBtnWrapperStyles(state.activeFrogType)}>
            {state.activeFrogType || state.lga ? (
              <span
                onClick={() => {
                  setOpenFilter(undefined);
                }}
                role="button"
              >
                <FontAwesomeIcon
                  style={{
                    fontSize: 16,
                    color: 'white',
                  }}
                  icon={faChevronLeft}
                />{' '}
                Apply
              </span>
            ) : (
              <span
                css={{
                  fontWeight: 'bold',
                  fontSize: pixelToRem(18),
                  lineHeight: '24pt',
                }}
              >
                {openFilter === 'lga' ? 'Filter by LGA' : 'Filter by Species'}
              </span>
            )}
            <div>
              <span
                role="button"
                onClick={() => {
                  if (openFilter === 'lga') {
                    dispatch(setLGA(undefined));
                  } else {
                    dispatch(setActiveFrogType(undefined));
                  }
                  setOpenFilter(undefined);
                }}
              >
                {(state.activeFrogType && openFilter === 'species') ||
                (state.lga && openFilter === 'lga') ? (
                  <span
                    css={{
                      marginRight: 10,
                    }}
                  >
                    Deselect
                  </span>
                ) : null}
                <FontAwesomeIcon
                  style={{
                    fontSize: 16,
                    color: 'white',
                  }}
                  icon={faTimes}
                />
              </span>
            </div>
          </div>
          {openFilter === 'lga' ? <LGAContent /> : <SpeciesContent />}
        </div>
      )}
    </div>
  );
}
